import React, { Fragment } from 'react';
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Dialog from 'libraries/Dialog';
import Button from '@mui/material/Button';

import styles from './styles';

const DeleteResultsDialog = ({ classes, open, failed = [], onClose }) => (
    <Dialog
        open={open}
        maxWidth="sm"
        className={classes.dialog}
        handleClose={onClose}
        contentClassName={classes.dialogContent}
    >
        <div>
            <Typography variant="h3" className={classes.successHeader}>
                Candidates Not Deleted
            </Typography>
            The following candidates were not deleted:
        </div>
        {
            failed.map((email, index) => (
                <Fragment key={email}>
                    {Boolean(index) && ', '}
                    <b key={index}>
                        { email }
                    </b>
                </Fragment>
            ))
        }
        <div className="u-mrg--tx3">
            <Button
                color="primary"
                onClick={onClose}
            >
                Go to Candidates
            </Button>
        </div>
    </Dialog>
);

export default withStyles(styles)(DeleteResultsDialog);
